var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(this.title)+" ")]),_c('van-image',{attrs:{"src":_vm.url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }